<template>
    <transition name="fade">
      <div v-show="chooseQty" :style="popupHeight" style="position: absolute; left: 77px; max-width: 200px; width: 200px; font-size: small;
        border-color: rgb(167, 199, 220); background-color: rgb(220, 235, 245); z-index: 9999; border-style: solid; border-width: 0.1px;">
        <div class="popup-arrow-border"></div>
        <div class="popup-arrow"></div>
        <div style="height: 30px; color: rgb(107, 106, 106); font-size: 15px; text-align: center; vertical-align: middle; border-bottom-style: solid;
                    border-bottom-width: 1px; border-color: rgb(204, 204, 204); box-shadow: rgb(228, 243, 251) 0px 1px 0px;">
          <div>  
            <div style="margin-top: 4px; float: left; margin-left: 10px;">{{$Jed.firstUpperTranslate('purchase')}}</div>
            <div style="cursor: pointer; float: right; margin-right: 5px; margin-top: 2px;" @click="closePurchasePopup()">
              <i :class="$root.icons.close"></i>
            </div>
          </div>
        </div>
        <div style="margin-left: 10px; margin-right: 10px;">
          <div class="truncEllipsisMultiline">{{purchaseDes}}</div>
          <div style="font-size: 13px; padding-left: 4px; overflow: hidden; text-overflow: ellipsis;">{{$Jed.firstUpperTranslate('code') + ': ' + purchaseSid}}</div>
          <cfg cid="purchasePopup.prezzo" tag='div'>
            <div v-if="purchasePrice" style="font-size: 13px; padding-left: 4px; overflow: hidden; text-overflow: ellipsis;">{{$Jed.firstUpperTranslate('price') + ': ' + purchasePrice}}</div>
          </cfg>
         
          <div class="input-group" style="padding: 7px;">
            <span class="input-group-btn">
              <button type="button" class="btn btn-default popup-btn-number" data-type="minus" :data-field="'quant[1]'+tableConfigs.title">
                  <span :class="this.$root.icons.minus"></span>
              </button>
            </span>

            <input type="number" :id="'popupquantita2Id'+tableConfigs.title" :name="'quant[1]'+tableConfigs.title" class="form-control popup-input-number" 
                  style="text-align: center;" value=""  @keydown.enter.prevent> 

            <span class="input-group-btn">
              <button type="button" class="btn btn-default popup-btn-number" data-type="plus" :data-field="'quant[1]'+tableConfigs.title">
                  <span :class="this.$root.icons.plus"></span>
              </button>
            </span>
          </div>

          <div style="display: flex; align-items: center; justify-content: center;">
            <button type="button" class="btn btn-default" style="font-size: 25px;" @click="putInCart()">
              <span :class="this.$root.icons.cart_in"></span>
            </button>
          </div>
        </div>
      </div> 
    </transition>
</template>

<script>

import { eventBus } from "../../eventbus";
import Cfg from "../dynamic/ConfigurableComponent.vue";

    export default {
        props: {
            chooseQty: Boolean,
            popupHeight: String,
            purchaseDes: String,
            purchaseSid: String,
            purchasePrice: String,
            product: Object,
            arrayToTable: Array,
            tableConfigs: Object
        },
        components: {
          Cfg
        },
        data: function(){
            return {
                minQuantity: 1,
                maxQuantity: 9999999
            }
        },
        created: function(){
            var vm = this;
            eventBus.$on("closePurchasePopup", () => {
                vm.closePurchasePopup();
            });
        },
        methods: {
            closePurchasePopup: function(){
                console.log('closing Purchase Popup')
                var vm = this;
                vm.chooseQty = false
                eventBus.$emit('chooseQtyChanged', vm.chooseQty)
            },
            /**
            * mette in carrello il prodotto nella quantità specificata
            */
            putInCart: function(){
                if(this.product != null) {
                    this.minQuantity = this.product.refObj.mqt
                    this.product.qty = parseFloat($("#popupquantita2Id"+this.tableConfigs.title).val());
                    if( this.product.qty < this.minQuantity || this.product.qty > this.maxQuantity){
                      //alert('Superata la quantità minima o massima ammessa per questo prodotto');
                      eventBus.$emit('alert', {
                        message: this.$Jed.firstUpperTranslate('Warning: minimum quantity is %1$s', null, {key: null, string: this.minQuantity}),
                        type: "warning",
                        action: ''
                      })
                      return;
                    }
                    var qty = this.$root.addProductToCart(this.product);
                    this.$root.saveDraft();
                    if( this.product.refObj ) this.product.refObj.qca = qty;

                    const idx = this.arrayToTable.indexOf(this.product.refObj);  
                    if( idx != null && idx >= 0) 
                    this.arrayToTable[idx]['qca'] = ((qty && qty > 0) ? qty : '');
                    $("#popupquantita2Id"+this.tableConfigs.title).val(((qty && qty > 0) ? qty : ''));
                    $('#'+this.tableConfigs.title).jqxGrid('updatebounddata','cells');
                    eventBus.$emit('refreshGrid')
                }
                this.closePurchasePopup();
            }
        }
    }
</script>
<style>
  .popup-arrow {
    width: 0px;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid rgb(220, 235, 245);
    display: table-cell;
    position: absolute;
    z-index: 9998;
    right: 199px;
    top: 168px;
  }

  .popup-arrow-border{
    width: 0px;
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
    border-right: 16px solid rgb(167, 199, 220);
    display: table-cell;
    position: absolute;
    z-index: 9998;
    right: 199px;
    top: 168px;
  }

  .truncEllipsisMultiline{
    font-size: 15px; 
    padding-left: 4px; 
    padding-top: 4px; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
</style>


// WEBPACK FOOTER //
// src/components/others/PurchasePopup.vue?3eda5d9d